import { useContext } from 'react';
import { ApisFormContext, getFullName } from '../../ApisForm.utils';
import { DocumentationRequired } from '../DocumentationRequired';
import { PersonalData } from '../PersonalData';
import { ModelApisInfant } from '../../ApisForm.model';
import { Divider } from '../../../Divider';
import { Icon, Text } from '../../../../foundations';

import styles from './PassengerInfant.module.css';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const PassengerInfant = () => {
	const context = useContext(ApisFormContext);
	const { typePassenger } = context.infant as ModelApisInfant;
	const { bookingInfoPassenger } = context;
	const args = { isInfant: true };
	return (
		<ErrorBoundaryProvider>
			<div className={styles.box_content}>
				<div className={styles.box_container}>
					<Divider variant="dashed" />
					<div className={styles.box_title}>
						<Icon name="bebes" className={styles.box_title_icon} />
						<Text as="h4" font="iberia-headline" data-testid="name-infant" className={styles.box_title_text}>
							{getFullName({ bookingInfoPassenger, existInfant: true })}
						</Text>
					</div>
					<PersonalData typePassenger={typePassenger} />
					<DocumentationRequired {...args} />
				</div>
			</div>
		</ErrorBoundaryProvider>
	);
};
PassengerInfant.displayName = 'PassengerInfant';
